import { cn } from '@/lib/cn'

/**
 * A rotating hairline arc. No dots, no pulse, no skeleton shimmer — the same
 * 1px rule the rest of the app is drawn in, turning.
 */
export function Spinner({ size = 14, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      role="presentation"
      className={cn('animate-spin motion-reduce:animate-none', className)}
    >
      <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeOpacity="0.2" strokeWidth="1" />
      <path d="M14.5 8A6.5 6.5 0 0 0 8 1.5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
    </svg>
  )
}
